import { usePathParam } from 'react-resource-router-next';

export const useCloudId = () => {
	const [cloudId] = usePathParam('cloudId');
	if (!cloudId) {
		throw new Error('Cloud Id must be provided in the route');
	}
	return cloudId;
};
